import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'
import Player from '../Player/Player'
import { useEffect, useRef } from 'react'
import { useMatchLog } from '@/root/context/MatchContext'
import getFormationPosition from '@/utils/data/getFormationPosition'

const FormationBlock = (props) => {
  const { players, modifiers, formation, playerType, setSelectedSpot } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const playerFormationRef = useRef()
  const formationBlockRef = useRef()
  const MatchState = useMatchLog()

  useEffect(() => {
    MatchState.setPlayerFormationRef(playerFormationRef.current)
  }, [playerFormationRef])

  // Set the height to the height of the first element in the main modal section
  useEffect(() => {
    setPlayerSize()
    window.addEventListener('resize', setPlayerSize)
    return () => window.removeEventListener('resize', setPlayerSize)
    // Run when the matchlog is opened so the shirtsizes are adjusted to the right size.
  }, [MatchState.visible])

  const setPlayerSize = () => {
    let playerSize = 45
    const formationWidth = formationBlockRef.current.clientWidth
    if (formationBlockRef.current) {
      // Bigger shirts when formationblock grows
      if (formationWidth > 600) playerSize = 65
      else if (formationWidth > 450) playerSize = 55
      // If not rendered (width = 0), use default
      else if (formationWidth === 0) playerSize = 45
      // Smaller shirts when formationblock shrinks
      else if (formationWidth < 300) playerSize = 30
      else if (formationWidth < 200) playerSize = 25

      formationBlockRef.current.style.setProperty('--Player-size', playerSize + 'px')
    }
  }
  return (
    <div ref={formationBlockRef} className={`FormationBlock${modifierClasses} ${'Formation--' + formation}`}>
      <Svg id="formation-background" modifiers={['FormationBlock-background']} />
      <div className="FormationBlock-players" ref={playerFormationRef}>
        {!!players?.length &&
          formation &&
          players.map((player, index) => {
            return (
              <Player
                type={playerType || player.icon}
                player={player}
                index={index}
                position={getFormationPosition(formation, index)}
                setSelectedSpot={setSelectedSpot}
                key={`Player${index}`}
              />
            )
          })}
      </div>
    </div>
  )
}

FormationBlock.defaultProps = {
  players: [],
  modifiers: [],
  formation: '',
  playerType: '',
  setSelectedSpot: () => {}
}

FormationBlock.propTypes = {
  players: PropTypes.array,
  modifiers: PropTypes.array,
  formation: PropTypes.string,
  playerType: PropTypes.string,
  setSelectedSpot: PropTypes.func
}

export default FormationBlock
